import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

export type BarResolution = components["schemas"]["BarResolution"];

// Intraday OHLC bars for a trade's candlestick chart (ADR 0033 U5). The
// endpoint resolves the symbol + window server-side and returns an empty bar
// list (rather than an error) when no price data is available, so the chart
// renders a graceful empty state. `enabled` lets the detail page defer the
// request until the Chart tab is actually shown.
export function useTradeChart(
  tradeId: string,
  resolution: BarResolution = "5m",
  enabled = true,
) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...TRADES_QUERY_KEY, "chart", tradeId, resolution],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/trades/{trade_id}/chart", {
        params: {
          path: { trade_id: tradeId },
          query: { resolution },
        },
      });
      if (error !== undefined) {
        throw new Error(`Failed to load chart for trade ${tradeId}`);
      }
      return data;
    },
    enabled: enabled && tradeId.length > 0,
  });
}
